import { CoreButton, CoreModalDialogFooter } from '@components'
import { GlobalContext, tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { type ReactNode, useContext } from 'react'

import './confirmationModal.scss'

type ConfirmationModalProps = {
  question: ReactNode
  onConfirm: () => void
  onCancel?: () => void
  className?: string
  confirmCaption?: string
  cancelCaption?: string
  hasCancel?: boolean
  icon?: ReactNode
  error?: unknown
  loading?: boolean
}

const ConfirmationModal = (props: ConfirmationModalProps) => {
  const {
    question,
    onConfirm,
    onCancel,
    className,
    confirmCaption,
    cancelCaption,
    hasCancel = true,
    icon,
    error,
    loading
  } = props

  const { modalHide } = useContext(GlobalContext)

  const handleCancel = () => {
    typeof onCancel === 'function' && onCancel()
    modalHide()
  }

  const handleConfirm = () => {
    typeof onConfirm === 'function' && onConfirm()
    modalHide()
  }

  return (
    <div data-test='confirmation-dialog-modal' className={className}>
      <div className='confirm-modal-wrapper'>
        {Boolean(icon) && <div className='icon'>{icon}</div>}
        <div className='confirm-content'>{question}</div>

        <ErrorDisplay className='error-wrapper' error={error} />

        <CoreModalDialogFooter>
          <div className='confirm-buttons'>
            <CoreButton
              className='action'
              variation='primary-black'
              size='large'
              onClick={handleConfirm}
              data-test='button-confirm'
              text={confirmCaption || tr('FRONTEND.BUTTONS.CONFIRM', 'Confirm')}
              isLoading={loading}
            />
            {hasCancel && (
              <CoreButton
                className='cancel'
                variation='tertiary'
                size='large'
                onClick={handleCancel}
                data-test='button-cancel'
                text={cancelCaption ? cancelCaption : tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
                isLoading={loading}
              />
            )}
          </div>
        </CoreModalDialogFooter>
      </div>
    </div>
  )
}

export default ConfirmationModal
